<template>
	<article class="small-12 propertyListing bgWhite borderRadius4 flex vertical-align animated fadeIn" v-if="property">
		<div class="small-12 large-4 columns flex vertical-align">
			<div class="small-12 large-3 cCard">
				<router-link :to="{ name: 'PropertyDetails', params: { id: property.id } }">
					<figure class="borderRadius4 flex justify-center vertical-align" style="background: url('https://firebasestorage.googleapis.com/v0/b/nestd-prod.appspot.com/o/framework%2Fcard-bokeh-bg.png?alt=media&token=4d1843e7-b908-409c-b7b5-6ab5fb528131') center center / cover no-repeat, linear-gradient(rgb(0, 152, 208), rgb(24, 187, 247));" v-if="property.links.media.length == 0">
						<i class="material-icons bgWhite cPrimaryDark flex justify-center vertical-align borderRadius4">home</i>
					</figure>
					<figure class="borderRadius4 flex justify-center vertical-align" :style="'background: url(' + property.links.media[0].url + ') center center / cover no-repeat;'" v-else>
						<i class="material-icons bgWhite cPrimaryDark flex justify-center vertical-align borderRadius4">home</i>
					</figure>
				</router-link>
			</div>
			<div class="small-12 large-9 propertyDetails">
				<router-link class="flex" :to="{ name: 'PropertyDetails', params: { id: property.id } }">
					<h6 class="small-12 text-overflow">{{property.attributes.title}}</h6>
					<p class="small-12 text-overflow">{{property.attributes.address.street_1}}</p>
				</router-link>
			</div>
		</div>
		<div class="small-12 large-2 columns flex vertical-align balance">
			<h6 class="small-12 flex vertical-align">
				<i class="material-icons-outlined">attach_money</i> 
				0.00
			</h6>
			<p class="small-12 trend flex vertical-align cGreen" v-if="future_item">
				<i class="material-icons-outlined cGreen borderRadius4 flex justify-center vertical-align north">north</i>
				+2.6%
			</p>
		</div>
		<div class="small-12 large-4 flex vertical-align stats">
			<div class="small-12 large-3 columns stat">
				<p class="small-12">0.00</p>
				<span class="small-12 flex vertical-align">
					GRM
					<i class="material-icons-outlined" v-tooltip="'Gross Rent Multiplier'">info</i>
				</span>
			</div>
			<div class="small-12 large-3 columns stat">
				<p class="small-12">0.00</p>
				<span class="small-12 flex">
					GIM
					<i class="material-icons-outlined" v-tooltip="'Gross Income Multiplier'">info</i>
				</span>
			</div>
			<div class="small-12 large-3 columns stat">
				<p class="small-12">0.00</p>
				<span class="small-12 flex">
					NIM
					<i class="material-icons-outlined" v-tooltip="'Net Income Multiplier'">info</i>
				</span>
			</div>
			<div class="small-12 large-3 columns stat">
				<p class="small-12">0.00</p>
				<span class="small-12 flex">
					Cap Rate
				</span>
			</div>
		</div>
		<div class="small-12 large-2 columns flex vertical-align justify-center actions">
			<a class="border borderRadius4 flex vertical-align justify-center edit" @click="throwDeleteModal()" v-tooltip="'Delete Property'">
				<i class="material-icons">delete</i>
			</a>
			<a class="border borderRadius4 flex vertical-align justify-center" @click="openMenuDropdown()">
				<i class="material-icons-outlined">more_horiz</i>
			</a>
			<div class="actionsMenu borderRadius4 bgWhite border animated fadeIn" v-if="openMenu" style="z-index:1000;">
				<ul class="small-12 flex">
					<li class="small-12 borderRadius4 transition">
						<router-link :to="{ name: 'PropertyDetails', params: { id: property.id } }" class="flex vertical-align cMedium">
							<i class="material-icons-outlined">roofing</i>
							Overview
						</router-link>
					</li>
					<li class="small-12 borderRadius4 transition">
						<router-link :to="{ name: 'PropertyUnits', params: { id: property.id } }" class="flex vertical-align cMedium">
							<i class="material-icons-outlined">home_work</i>
							Units
						</router-link>
					</li>
					<li class="small-12 borderRadius4 transition">
						<router-link :to="{ name: 'PropertyResidents', params: { id: property.id } }" class="flex vertical-align cMedium">
							<i class="material-icons-outlined">supervised_user_circle</i>
							Residents
						</router-link>
					</li>
					<li class="small-12 borderRadius4 transition" v-if="future_item">
						<a class="flex vertical-align cMedium">
							<i class="material-icons-outlined">list_alt</i>
							Activity
						</a>
					</li>
					<li class="small-12 borderRadius4 transition" v-if="future_item">
						<a class="flex vertical-align cMedium">
							<i class="material-icons-outlined">account_balance</i>
							Operations
						</a>
					</li>
					<li class="small-12 borderRadius4 transition" v-if="future_item">
						<a class="flex vertical-align cMedium">
							<i class="material-icons-outlined">money_off</i>
							Expenses
						</a>
					</li>
					<li class="small-12 borderRadius4 transition" v-if="future_item">
						<a class="flex vertical-align cMedium">
							<i class="material-icons-outlined">present_to_all</i>
							Goals
						</a>
					</li>
					<li class="small-12 borderRadius4 transition" v-if="future_item">
						<a class="flex vertical-align cMedium">
							<i class="material-icons-outlined">insights</i>
							Forecast
						</a>
					</li>
					<li class="small-12 borderRadius4 transition" v-if="future_item">
						<a class="flex vertical-align cMedium">
							<i class="material-icons-outlined">bar_chart</i>
							Reporting
						</a>
					</li>
				</ul>
			</div>
		</div>
	</article>
</template>

<script>

	// Import the mixins
	import { PropertiesRepository } from '@/components/mixins/repositories/properties/PropertiesRepository'
	import { SpinnerMethods } from '@/mixins/helpers/SpinnerMethods'
	import { CompanyRepository } from '@/components/mixins/repositories/companies/CompanyRepository'
	
	export default {

		/*
		** Set the component name
		*/

		name: 'PropertyListing',

		/*
		**  Register the mixins
		*/

		mixins: [

			PropertiesRepository,
			SpinnerMethods,
			CompanyRepository

		],

		/*
		**  Set the props
		*/

		props: {

			property: {
				type: Object,
				default: () => null
			},
			company: {
				type: Object,
				default: () => null
			}

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			openMenu: false,
			future_item: false

		}),

		/*
		**  Do this first
		*/

		created() {

			window.addEventListener("click", this.closeMenu);

		},

		/*
		**  Do this last
		*/

		beforeDestroy() {

			window.removeEventListener("click", this.closeMenu);

		},

		/*
		**  Set up the methods
		*/

		methods: {

			openMenuDropdown: function() {

				// Set the prop
				if (!this.openMenu) {

					this.openMenu = true;

				} else {

					this.openMenu = false;

				}

			},

			closeMenu: function(e) {

		    	if (!this.$el.contains(e.target)) this.openMenu = false;

		    },

		    throwDeleteModal: function() {

		    	this.$swal({

  					title: 'Are you sure?',
  					text: "This will permanently delete the property from your portfolio.",
  					icon: 'warning',
  					showCancelButton: true,
  					confirmButtonColor: '#18bbf7',
  					cancelButtonColor: '#d33',
  					confirmButtonText: 'Yes, delete it!'

				}).then((result) => {

					// Show the spinner
					this.showSpinner();

					// Delete the property
					if (result.value) {

						this.deletePropertyListing(this.property.id)

					} else {

						// Hide the spinner
						this.hideSpinner();

					};

				});

		    }

		}

	}

</script>